import { Routes } from '@angular/router';
import { HelpComponent } from './help/help.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';

export const supportRoutes: Routes = [
    { path: ':clientCode/help-and-support', component: HelpComponent },
    { path: ':clientCode/privacy-policy', component: PrivacyPolicyComponent },
    { path: ':clientCode/terms-of-use', component: TermsOfUseComponent }
];
